module.exports = __webpack_public_path__ + "media/images/dot_grid_light-5d6d47a89e5b41eabe52b8eba961c929.png";